import React from 'react';
import {
  Box,
  CloseIcon,
  HorizontalDivider,
  theme,
  TransparentButton,
  Typography,
  WarningIcon,
} from '@ttx/design-system';

interface GuestListModalProps {
  onClose: () => void;
}

export const GuestListModal: React.FC<GuestListModalProps> = ({
  onClose,
}: GuestListModalProps) => {
  return (
    <Box
      w="100%"
      maxWidth={588}
      minWidth={['inherit', 588]}
      borderColor="outlines"
      borderWidth="one"
      borderStyle="solid"
    >
      <Box
        paddingX="md"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box flexDirection="row" alignItems="center">
          <WarningIcon size={12} />
          <Box ml="two">
            <Typography color="textDefault" textStyle="s">
              Wallet address not elligible
            </Typography>
          </Box>
        </Box>
        <TransparentButton onPress={onClose} style={{padding: theme.space.md}}>
          <CloseIcon size={18} />
        </TransparentButton>
      </Box>
      <HorizontalDivider />
      <Box paddingX="md" paddingY="lg">
        <Typography textStyle="s" color="textDefault">
          It looks like your wallet address isn&apos;t eligible to complete the
          purchase at the moment.
        </Typography>
        <Box mt="md" />
        {/* <Typography textStyle="s" color="textDefault">
          This NFT is currently exclusive to those who registered for the access
          list and won in the raffle. The NFT will be open to all collectors on
          Wednesday 3rd August 6PM.
        </Typography>
        <Box mt="md" /> */}
      </Box>
      <HorizontalDivider />
      <TransparentButton onPress={onClose}>
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          paddingY="s"
        >
          <Typography textStyle="s" color="textDefault">
            Got it
          </Typography>
        </Box>
      </TransparentButton>
    </Box>
  );
};
